import { Container, Row, Col } from "react-bootstrap";
import { Envelope, Linkedin, Github } from "react-bootstrap-icons";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { profile } from "../data/content";

export const Contact = () => {
  return (
    <section className="contact" id="contato">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            <TrackVisibility once>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="" aria-hidden="true"/>
              }
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6}>
            <TrackVisibility once>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Vamos conversar?</h2>
                  <p>
                    Procurando alguém para o seu time ou para tirar um projeto do papel?
                    Me manda uma mensagem que eu respondo rápido.
                  </p>
                  <div className="contact-links">
                    <a className="primary" href={`mailto:${profile.email}`}>
                      <Envelope size={20} /> {profile.email}
                    </a>
                    <a href={profile.linkedin} target="_blank" rel="noopener noreferrer">
                      <Linkedin size={20} /> LinkedIn
                    </a>
                    <a href={profile.github} target="_blank" rel="noopener noreferrer">
                      <Github size={20} /> GitHub
                    </a>
                  </div>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
